import { View, Text } from "react-native";
import React from "react";
import { Popover as RTP, PopoverProps } from "react-tiny-popover";

const Popover = (props: PopoverProps) => {
  return <RTP {...props}></RTP>;
};

export default Popover;
